import { generateTutorial, generateScript, trackEvent } from './helpers'

export default {
  init: ({ commit }, { level, resume }) => {
    const history = resume && localStorage.getItem('history')
      ? JSON.parse(localStorage.getItem('history'))
      : []
    commit('INIT_GAME', { level, history })
  },

  start: ({ commit, state }) => {
    trackEvent('game started', state.history && state.history.length > 0 ? 'continue' : 'new')
    commit('LOAD_SCRIPT', generateTutorial())
  },

  next: ({ commit, state }) => {
    const { scene, mutations, badges, history } = state

    if (scene.isCompleted && badges.length === 3) {
      trackEvent('game completed', '')
      commit('END_GAME')
    } else if (mutations.length) {
      commit('NEXT_SCENE')
    } else {
      if (history.length) {
        const lastItem = history.slice(-1)[0]
        const totalQuestions = history.filter(item => item.type === 'question').length

        if (lastItem.type === 'question' && totalQuestions === 5) {
          trackEvent('five questions played', '')
        }
      }
      commit('LOAD_SCRIPT', generateScript(state))
    }
  },

  skip: ({ commit, state }) => {
    commit('LOAD_SCRIPT', generateScript(state))
  },

  submitManifest: ({ commit, state }, manifest) => {
    if (manifest) {
      commit('SUBMIT_MANIFEST', manifest)
    } else {
      const mutations = state.mutations.map(mutation => {
        return mutation.isCompleted
          ? { ...mutation, instruction: null }
          : { ...mutation }
      })
      commit('OVERWRITE', { mutations })
    }
  },

  submitBadge: ({ commit }, badge) => {
    if (badge) {
      trackEvent('badge earned', badge)
      commit('SUBMIT_BADGE', badge)
    }
  },

  loadAnimation: ({ commit }, type) => {
    commit('LOAD_ANIMATION', type)
  },

  clearAnimation: ({ commit }) => {
    commit('LOAD_ANIMATION', null)
  },

  toggleMute: ({ commit }) => {
    commit('TOGGLE_MUTE')
  },

  reset: ({ commit }) => {
    commit('RESET')
  }
}
